import type { FC, ReactNode } from 'react';
import React from 'react';

import type { TTimerText } from '../../models';

type TTimerTextDisplayProps = Pick<TTimerText, 'timerText' | 'styles' | 'Text'> & {
    children: ReactNode;
    endText: string;
    startText: string;
};

export const TimerTextDisplay: FC<TTimerTextDisplayProps> = ({
    Text,
    children,
    endText,
    startText,
    timerText,
}) => (
    <>
        {startText}
        <Text tag="span" {...timerText}>
            {children}
        </Text>
        {endText}
    </>
);
